module.exports = __webpack_public_path__ + "static/insurance-body-1-8f7864bb27f85f396da8e6ff8395f1e6.jpg";